import { createContext, FC, useContext, useEffect } from 'react';
import { getJTI, getWeaveToken } from '@frontend/auth-helpers';
import { IHTTP, HTTP } from './http';
import { HeaderSubscriptionPlugin } from './plugins/header-subscription-plugin';

const Context = createContext<IHTTP>({});

export const FetchProvider: FC<React.PropsWithChildren<IHTTP>> = ({ baseUrl = '', headers, children }) => {
  return <Context.Provider value={{ baseUrl, headers }}>{children}</Context.Provider>;
};

export const http = new HTTP({
  getAuthorizationHeader: () => {
    const authorizationToken = getJTI() || getWeaveToken();
    return authorizationToken ? `Bearer ${authorizationToken}` : undefined;
  },
});
export const headerPlugin = new HeaderSubscriptionPlugin();
http.addPlugin(headerPlugin);

const resolveParams = ({ context, props }: { context?: IHTTP; props?: IHTTP }) => {
  return {
    ...context,
    ...props,
  };
};

export const useFetch = (props?: IHTTP): HTTP => {
  const context = useContext(Context);
  useEffect(() => {
    const { baseUrl, headers } = resolveParams({ context, props });
    if (headers) {
      http.setHeaders(headers);
    }

    if (baseUrl) {
      http.setBaseUrl(baseUrl);
    }
  }, [props, context]);

  return http;
};
